import { Helmet } from 'react-helmet';
import Card from '../../generic/Card/Card';
import styles from './style.module.less';
import Tabs, { useTabs } from '../../generic/Tabs';
import InvoiceHistoryContent from '../billing/InvoiceHistoryContent';
import { window } from '../../../globals';
import Plans from './plans';

type Tab = 'Current Plan' | 'Invoice History' | 'Payment Method' | 'Plans';

const Subscription = () => {
  const tabIds: Tab[] = ['Current Plan'];
  const hasCustomBilling = window.user?.organization?.custom_billing;
  const isOnPrem = window.on_prem;

  if (!hasCustomBilling && !isOnPrem) {
    tabIds.push('Invoice History', 'Payment Method', 'Plans');
  }

  const {
    tabs,
    activeTab,
  } = useTabs({ tabIds });

  const shouldShowInvoiceHistory = !hasCustomBilling && activeTab === 'Invoice History';
  const shouldShowPlans = !hasCustomBilling && activeTab === 'Plans';

  return (
    <div className="container margin-top">
      <Helmet title="Subscription" />
      <Card isFullWidth>
        <Card.Header>
          <h1 className={styles.header}>Subscription</h1>
        </Card.Header>
        <Card.Content>
          <Tabs>
            {tabs.map((tab) => (
              <Tabs.Tab
                key={tab.label}
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...tab}
                onSelect={() => {
                  tab.onSelect();
                }}
              />
            ))}
          </Tabs>

          {shouldShowInvoiceHistory && <InvoiceHistoryContent />}
          {shouldShowPlans && <Plans />}
        </Card.Content>
      </Card>
    </div>
  );
};

export default Subscription;
